import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
// 引入所有图标 (保证 Layout 中的 Menu 图标能显示)
import * as ElementPlusIconsVue from '@element-plus/icons-vue' 

import App from './App.vue'
import router from './router' // 引入路由配置

const app = createApp(App)
const pinia = createPinia()

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(pinia)
app.use(ElementPlus, { locale: zhCn })
app.use(router) // 使用路由
app.mount('#app')
